import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { DtoBase } from '@models/base/dtoBase.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class EstadoRegistroContableService {

  constructor(private http:HttpClient) {
  }

  create(createKeyValueRequest:CreateKeyValueRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/EstadoRegistroContable/Create",createKeyValueRequest);
  }

  update(updateKeyValueRequest:UpdateKeyValueRequest):Observable<any>
  {
    return  this.http.put<any>("/api/EstadoRegistroContable/Update",updateKeyValueRequest);
  }

  getAll():Observable<DtoBase[]> {
    return   this.http.get<DtoBase[]>("/api/EstadoRegistroContable/GetAll");
  }

  getById(id:number):Observable<DtoBase>{
    return  this.http.get<DtoBase>("/api/EstadoRegistroContable/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/EstadoRegistroContable/Delete?id=" + id);
    else
      return of(null)
  }

}
